import useFocus from "@/lib/hooks/interactions/other/useFocus";
import { AlertColorType } from "@/lib/main";
import { CSSProperties, PropsWithChildren } from "react";
import formStyle from "./formStyle.shared";

type Props = PropsWithChildren<{
  name: string;
  maxLength: number;
  cols: number;
  rows: number;
  placeholder: string;
  value: string;
  setValue: (value: string) => void;
  valueValid?: boolean;
  required?: boolean;
  disabled?: boolean;
  textAreaRef: React.RefObject<HTMLTextAreaElement | null>;
  textAreaKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  alertColor?: AlertColorType;
}>;

export default function TextArea({
  children,
  name,
  maxLength,
  cols,
  rows,
  placeholder,
  value,
  setValue,
  valueValid,
  required,
  disabled,
  textAreaRef,
  textAreaKeyDown,
  alertColor,
}: Props) {
  const { isFocused, onFocus, onBlur } = useFocus();
  const shareStyle = formStyle({ value, isFocused, alertColor, disabled });
  const styles: CSSProperties = {
    ...shareStyle,
    ...{
      marginTop: "var(--spacing-xs)",
      padding: "var(--spacing-md)",
      resize: "none",
    },
  };

  return (
    <textarea
      ref={textAreaRef}
      name={name}
      maxLength={maxLength}
      cols={cols}
      rows={rows}
      placeholder={placeholder}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      aria-invalid={!valueValid}
      onKeyDown={textAreaKeyDown}
      required={required}
      style={styles}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      {children}
    </textarea>
  );
}
